<template lang="html">
	<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
		<path style="fill:#78B9EB;" d="M426.667,512H85.333C73.551,512,64,502.449,64,490.667V21.333C64,9.551,73.551,0,85.333,0h245.333
			L448,117.333v373.333C448,502.449,438.449,512,426.667,512z"/>
		<path style="fill:#679FC9;" d="M330.667,0v96c0,11.782,9.551,21.333,21.333,21.333h96L330.667,0z"/>
		<path style="fill:#FFC374;" d="M117.333,213.333c-5.891,0-10.667,4.776-10.667,10.667v160c0,5.891,4.776,10.667,10.667,10.667h96
			L256,405.333v-192H117.333z"/>
		<path style="fill:#FBB040;" d="M394.667,213.333H256v192l42.667-10.667h96c5.891,0,10.667-4.776,10.667-10.667V224
			C405.333,218.109,400.558,213.333,394.667,213.333z"/>
		<path style="fill:#FFEB99;" d="M213.333,192h-64c-5.891,0-10.667,4.776-10.667,10.667V352c0,5.891,4.776,10.667,10.667,10.667h64
			L256,373.333V202.667L213.333,192z"/>
		<path style="fill:#FFE477;" d="M288,192l-32,10.667v170.667l42.667-10.667h64c5.891,0,10.667-4.776,10.667-10.667V202.667
			c0-5.891-4.776-10.667-10.667-10.667H288z"/>
		<g>
			<path style="fill:#FFFFFF;" d="M128,64h21.333v21.333H128V64z"/>
			<path style="fill:#FFFFFF;" d="M170.667,64h42.667v21.333h-42.667V64z"/>
			<path style="fill:#FFFFFF;" d="M128,106.667h85.333V128H128V106.667z"/>
			<path style="fill:#FFFFFF;" d="M288,234.667h53.333V256H288V234.667z"/>
			<path style="fill:#FFFFFF;" d="M288,266.667h53.333V288H288V266.667z"/>
			<path style="fill:#FFFFFF;" d="M288,298.667h53.333V320H288V298.667z"/>
			<path style="fill:#FFFFFF;" d="M170.667,234.667H224V256h-53.333V234.667z"/>
			<path style="fill:#FFFFFF;" d="M170.667,266.667H224V288h-53.333V266.667z"/>
			<path style="fill:#FFFFFF;" d="M170.667,298.667H224V320h-53.333V298.667z"/>
		</g>
	</svg>
</template>

<script>
export default {
  name: 'Cbpf'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/illustration/Cbpf.vue